module.exports = __webpack_public_path__ + "static/media/obsessive Compulsive DisorderActive.92b21104.svg";